import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/auth/Login.vue'
import Logout from './views/auth/Logout.vue'
import Faq from './views/Faq.vue'
import Disclaimer from './views/Disclaimer.vue'
import LostPassword from './views/auth/LostPassword.vue'
import Signup from "@/views/auth/Signup";
import Account from "@/views/auth/Account";
import Searchlist from "@/views/Searchlist";
import Detailed from "@/views/Detailed";
import Logincheck from "@/views/auth/Login-check";
import Compare from "@/views/Compare";
import Contact from "@/views/Contact";
import Referral from "@/views/Referral";
/*import Detailedview3 from "@/views/3cols";
import NewDetailedview3 from "@/views/3colsNuevo.vue";*/
import Test from "@/views/Test.vue";
import Referral2 from "@/views/Referral2.vue";
import Watchlist from "@/views/Watchlist";
import TopFunList from "@/views/TopFunList";
import Dashboard from "@/views/Dashboard";
import Privacy from "@/views/Privacy";
import Blog from "@/views/Blog";
import Blogpage from "@/views/Blogpage";
import Staticpage from "@/views/Staticpage";

import LostpwSignin from "@/views/auth/LostpwSiginin";
import ChangePassword from "@/views/auth/ChangePassword";
import auth from "@/store/modules/auth"
import Page404 from './views/Page404.vue'
import store from "./store/index";
import Guideline from "./views/Guideline";
import GuidelineShadrack from "./views/GuidelineShadrack";
import GuidelineBaxter from "./views/GuidelineBaxter";
import FundNewsRecap from "./views/FundNewsRecap.vue";
import CompoundReturnCalculator from './views/CompoundReturnCalculator.vue'
import ConfirmUnsubscribeEmail from './views/ConfirmUnsubscribeEmail.vue'
import ActivePassive from './views/ActivePassive.vue'
import ITOpenEnded from './views/ITOpenEnded.vue'
import ESGvsNonESG from './views/ESGvsNonESG.vue'
Vue.use(Router)


// const ifAuthenticated = async (to, from, next) => {
//     if (auth.state.authenticated === null){
//         next('/login-check')
//     }
//     else if (auth.state.authenticated === true) {
//         next()
//     }
//     else if(auth.state.authenticated === false){
//         next('/login')
//     }
// }

const clicker = async (to, from, next) => {
    if (auth.state.authenticated !== true) {
        if (typeof localStorage !== 'undefined' /* function to detect if localstorage is supported*/) {
            let c = parseInt(localStorage.getItem('comparecount'))
            if(isNaN(c)){
                c = 0
            }
            if (c > 4) {
                store.commit("auth/SET_HITTING_LIMIT", 'comparison')
                store.commit("auth/SET_CLICKER_LIMIT", to.path)
                next("/login/max-5")
            }
            localStorage.setItem('comparecount', (c + 1).toString())
        }
    }
    else localStorage.removeItem('comparecount');
    next()
}

const clicker2 = async (to, from, next) => {
    if (auth.state.authenticated !== true) {
        if (typeof localStorage !== 'undefined' /* function to detect if localstorage is supported*/) {
            let c = parseInt(localStorage.getItem('comparecount2'))
            if(isNaN(c)){
                c = 0
            }
            if (c > 4) {
                store.commit("auth/SET_HITTING_LIMIT", 'referral')
                store.commit("auth/SET_CLICKER_LIMIT", to.path)
                next("/login/max-5")
            }
            localStorage.setItem('comparecount2', (c + 1).toString())
        }
    }
    else localStorage.removeItem('comparecount2');
    next()
}

const handleAuthenticated = async (to, from, next) => {
    if(auth.state.authenticated) next('/')
    else next();
}

const handleLogin = async (to, from, next) => {
    if(auth.state.authenticated===false) next('/login/max-5')
    else next();
}

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [

        {
            path: '/login/:id?',
            name: 'Login',
            component: Login,
            beforeEnter: handleAuthenticated,
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard,
            beforeEnter: handleLogin
        },
        {
            path: '/alert',
            name: 'Alert',
            component: Dashboard,
            beforeEnter: handleLogin
        },
        {
            path: '/test',
            name: 'Test',
            component: Test
        },
        {
            path: '/compare-fund-to-peers/:id/:text',
            name: 'Comparison',
            component: Compare,
            beforeEnter: clicker,
        },
        {
            path: '/platforms-whereto-invest/:id/:text',
            name: 'Referral',
            component: Referral,
            beforeEnter: clicker2,

        },
        {
            path: '/referral-mockup',
            name: 'Referral2',
            component: Referral2,
            beforeEnter: clicker2,
        },
        {
            path: '/logout',
            name: 'Logout',
            component: Logout
        },
        {
            path: '/lostpassword',
            name: 'Lostpassword',
            component: LostPassword
        },
        {
            path: '/login-check',
            name: 'Logincheck',
            component: Logincheck
        },
        {
            path: '/register',
            name: 'Signup',
            component: Signup,
            beforeEnter: handleAuthenticated,
        },
        {
            path: '/account',
            name: 'Profile',
            component: Account,
            //beforeEnter: ifAuthenticated,
        },
        {
            path: '/search-investment-funds/:id/:text',
            name: 'Results',
            component: Searchlist
        },
        {
            path: '/faq',
            name: 'Faq',
            component: Faq
        },
        {
            path: '/fund-details/:id/:text',
            name: 'Detailedview Results',
            component: Detailed
        },
        {
            path: '/fund-details/:id/:text',
            name: 'Detailedview Top Funds List',
            component: Detailed
        },
        {
            path: '/detailed-watchlist/:id',
            name: 'Detailedview Shortlist',
            component: Detailed
        },
        {
            path: '/detailed-compare/:id',
            name: 'Detailedview Comparison',
            component: Detailed
        },
        {
            path: '/contact',
            name: 'Contactform',
            component: Contact
        },
        {
            path: '/disclaimer',
            name: 'Disclaimer',
            component: Disclaimer
        },
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/privacy',
            name: 'Privacy Policy',
            component: Privacy
        },
        {
            path: '/legal/:id',
            name: 'Legal',
            component: Privacy
        },
        {
            path: '/page/:id',
            name: 'Page',
            component: Privacy
        },
        {
            path: '/watchlist',
            name: 'Watchlist',
            component: Watchlist,
            beforeEnter: handleLogin
        },
        {
            path: '/lostpw-signin/:id',
            name: 'Lostpwsignin',
            component: LostpwSignin
        },
        {
            path: '/change-password',
            name: 'ChangePassword',
            component: ChangePassword
        },
        {
            path: '/blog',
            name: 'Blog',
            component:Blog
        },
        {
            path: '/blog/:id/:slug',
            name: 'Blogpage',
            component:Blogpage
        },

        {
            path: '/about',
            name: 'About',
            component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        },
        {
            path: '/how-to-choose-a-multi-asset-fund-with-pete-matthew',
            name: 'Guideline',
            component: Guideline
        },
        {
            path: '/how-to-choose-an-active-global-equity-large-cap-fund-with-ian-shadrack',
            name: 'GuidelineShadrack',
            component: GuidelineShadrack
        },
        {
            path: '/how-to-track-fund-performance-with-dave-baxter',
            name: 'GuidelineBaxter',
            component: GuidelineBaxter
        },
        {
            path: '/fund-news-recap',
            name: 'FundNewsRecap',
            component: FundNewsRecap
        },
        {
            path: '/compound-returns-calculator-for-fund-investing-uk',
            name: 'CompoundReturnCalculator',
            component: CompoundReturnCalculator
        },
        {
            path: '/popular-top-funds',
            name: 'TopFunList',
            component: TopFunList
        },
        {
            path: '/confirm-unsubscribe-email/:id',
            name: 'ConfirmUnsubscribeEmail',
            component: ConfirmUnsubscribeEmail
        },
        {
            path: '/active-vs-passive',
            name: 'ActivePassive',
            component: ActivePassive
        },
        {
            path: '/investment-trust-vs-open-ended',
            name: 'ITOpenEnded',
            component: ITOpenEnded
        },
        {
            path: '/esg-vs-non-esg',
            name: 'ESGvsNonESG',
            component: ESGvsNonESG
        },
        {
            path: '/pages/:slug',
            name: 'Pages',
            component: Staticpage
        },
        { path: "*", component: Page404 }

    ],
    async scrollBehavior (to, from, savedPosition) {
        if(to.name == "Comparison"){
            return { x: 0, y: 0 }
        }
        else if(to.name == 'Results' && from.name != "Home"){
            if (savedPosition) {
              to.meta.savedPosition = savedPosition
            }
        } else if(to.name == 'Blog'){
          if (savedPosition) {
            to.meta.savedPosition = savedPosition
          }
        }
        if (savedPosition) {
            await new Promise(resolve => setTimeout(resolve, 500));
            return savedPosition;
        }
        return { x: 0, y: 0 }
    }
})
